import { useState, forwardRef } from "react";
import DOMPurify from "dompurify";
import { FAQs } from "../siteUtils";
import "./FAQ.css";

const FAQ = forwardRef((_, ref) => {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = (panel) => {
    setExpanded((current) => (current === panel ? false : panel));
  };

  return (
    <section className="faq-section" ref={ref}>
      <div className="faq-wrapper">
        <header className="faq-header">
          <p className="faq-eyebrow">Good to know</p>
          <h2>FAQ's</h2>
          <p>
            Answers to the questions Linda hears most often about energy
            clearing, land healing, and spiritual support.
          </p>
        </header>

        <div className="faq-grid">
          {FAQs.map(({ question, answer }, index) => {
            const isOpen = expanded === index;

            return (
              <article
                className={`faq-card${isOpen ? " open" : ""}`}
                key={question}
              >
                <button
                  type="button"
                  className="faq-card-toggle"
                  onClick={() => handleToggle(index)}
                  aria-expanded={isOpen}
                  aria-controls={`faq-panel-${index}`}
                  id={`faq-question-${index}`}
                >
                  <span className="faq-question">{question}</span>
                  <span
                    className={`faq-toggle ${isOpen ? "open" : ""}`}
                    aria-hidden="true"
                  />
                </button>

                <div
                  className={`faq-answer-wrapper${isOpen ? " open" : ""}`}
                  id={`faq-panel-${index}`}
                  role="region"
                  aria-labelledby={`faq-question-${index}`}
                >
                  <div
                    className="faq-answer"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(answer),
                    }}
                  />
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
});

export default FAQ;
